import React from 'react';
import { BrowserRouter as Router, Routes } from 'react-router-dom';
// import { createBrowserHistory } from 'history';
import AppLayout from './components/layouts/AppLayout';

// Enable Browser History for Back and Forward Button
// export const appHistory = createBrowserHistory();

function Stepper3() {
  //https://fullstacksoup.blog/2021/09/27/react-material-form-validation-with-formik/
  return (
    <div>
      {/* <Router history={appHistory}> */}
      {/* <Routes> */}
      <AppLayout />
      {/* </Routes> */}
      {/* </Router> */}
    </div>
  );
}

export default Stepper3;
